import React from 'react';
import IconButtonComponent, { IconButtonProps } from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';

import { LinkIcon } from 'components/icons/LinkIcon';
import { colors, styled } from 'core/styles';

type Props = {
  href: string;
  tooltip?: string;
  icon?: React.ReactNode;
} & IconButtonProps<'a'>;

export function ExternalLinkButton({ tooltip = '', icon, ...rest }: Props) {
  return (
    <Tooltip title={tooltip} placement="bottom">
      <div>
        <IconButton {...rest} component="a" target="_blank" rel="noopener noreferrer">
          {icon || <LinkIcon fontSize="inherit" />}
        </IconButton>
      </div>
    </Tooltip>
  );
}

const IconButton = styled(IconButtonComponent<'a'>)(({ theme }) => ({
  padding: '6px 6px 6px 7px',
  borderRadius: 6,
  fontSize: 'inherit',
  color: 'inherit',
  lineHeight: 0,
  verticalAlign: 'middle',
  background: colors.grayOpacity[24],
  transition: theme.transitions.create('background'),

  '&:hover': {
    background: colors.grayOpacity[48],
  },
}));
